/*global angular */
/*jslint node: true */

'use strict';

var address = angular.module('address', []);
address.directive('addressSlot', ['$templateCache', function ($templateCache) {
    return {
        template: $templateCache.get('slots/address/address.html')
    };
}]);
